import { render, staticRenderFns } from "./MakePayout.vue?vue&type=template&id=5cb5bc4d&lang=pug&"
import script from "./MakePayout.vue?vue&type=script&lang=js&"
export * from "./MakePayout.vue?vue&type=script&lang=js&"
import style0 from "./MakePayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
